import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { toast } from 'react-toastify';
import { confirmAlert } from 'react-confirm-alert';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import * as actions from '../../redux/actions/actions-contest';
import Button from '../../components/Button';
import SearchBar from '../../components/SearchBar';
import BreadCrumb from '../../components/Breadcrumb';
import Loader from '../../components/Loader';

class Contest extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchVal: ''
    };
    props.getContestlist();
  }


  deleteContest = (id) => {
    confirmAlert({
      title: 'Delete Contest',
      message: 'Are you sure to delete the Contest?',
      buttons: [
        {
          label: 'Yes',
          onClick: () => {
            this.props.deleteContest(id)
              .then(() => {
                toast.success('Deleted Successfully');
              }).catch((error) => {
                toast.error(error.message);
              });
          }
        },
        {
          label: 'No'
        }
      ]
    });
  }

  handleTableFilter = (search) => {
    this.setState({ searchVal: search });
  }

  setTableOption = () => (this.props.contestList && this.props.tableLoading ? <Loader /> : 'No Data Found');

  render() {
    const searchVal = this.state.searchVal.toLowerCase();
    const contest = this.props.contestList.filter((item) => item.Title.toLowerCase().includes(searchVal));

    const columns = [{
      dataField: 'Title',
      text: 'Contest Name'
    }, {
      dataField: 'SlugURL',
      text: 'Slug URL'
    }, {
      dataField: 'CreatedDateTime',
      text: 'Created at',
      formatter: (cell, row) => (
        new Date(cell).toLocaleDateString()
      ),
      sort: true
    }, {
      dataField: 'Id',
      text: 'Actions',
      headerStyle: {
        width: '140px'
      },
      formatter: (cell, row) => (
        <>
          <span
            role="presentation"
            className="fa fa-pencil-alt tableEdit"
            onClick={() => this.props.history.push(`/Contest-editor/${cell}`)}
          />
          <span
            role="presentation"
            className="fa fa-trash tableDelete"
            onClick={() => this.deleteContest(cell)}
          />
        </>
      )
    }];

    const defaultSorted = [{
      dataField: 'CreatedDateTime',
      order: 'desc'
    }];

    return (
      <div>
        <div className="container">
          <BreadCrumb currentPage="Contest" />
          <div className="col-md-12 py-3 mb-5">
            <div className="card border-secondary">
              <div className="card-header">
                <div className="row">
                  <div className="col-md-10">
                    {/* <span className="fa fa-trophy cardTitle"> Contest</span> */}
                    <SearchBar
                      placeholder="Search by Contest Name"
                      handleChange={(e) => this.handleTableFilter(e.target.value)}
                    />
                  </div>
                  <div className="col-md-2 text-right">
                    <Button
                      className="btn btn-sm btn-secondary"
                      onClick={() => this.props.history.push('/contest-editor/0')}
                    >
                      <span className="fas fa-plus" />
                      {' '}
                      Add New
                    </Button>
                  </div>
                </div>
              </div>
              <div className="card-body text-secondary">

                <BootstrapTable
                  keyField="Id"
                  data={contest}
                  columns={columns}
                  pagination={paginationFactory()}
                  defaultSorted={defaultSorted}
                  noDataIndication={() => this.setTableOption()}
                  hover
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

Contest.defaultProps = {
  tableLoading: false,
  contestList: null,
  getContestlist: null,
  deleteContest: null
};

Contest.propTypes = {
  tableLoading: PropTypes.bool,
  contestList: PropTypes.array,
  getContestlist: PropTypes.func,
  deleteContest: PropTypes.func
};

const mapStateToProps = ({ contest }) => ({
  tableLoading: contest.tableLoading,
  contestList: contest.contestList
});

const mapDispatchToProps = (dispatch) => ({

  getContestlist: () => dispatch(actions.fetchContest()),
  deleteContest: (id) => dispatch(actions.deleteContest(id))

});

export default connect(mapStateToProps, mapDispatchToProps)(Contest);
